var u = (n, t, r) => new Promise((T, o) => {
  var c = (e) => {
    try {
      a(r.next(e));
    } catch (i) {
      o(i);
    }
  }, g = (e) => {
    try {
      a(r.throw(e));
    } catch (i) {
      o(i);
    }
  }, a = (e) => e.done ? T(e.value) : Promise.resolve(e.value).then(c, g);
  a((r = r.apply(n, t)).next());
});
import { selfAxios as p } from "@oppein/op-utils";
function s(n) {
  return u(this, null, function* () {
    const {
      data: t
    } = yield p.get(
      "/ucenterapi/uc/internal/department/getOrganizationalStructureTreeToMTDSByOrgType",
      { params: n }
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  s as getGetOrganizationalStructureTreeToMTDSByOrgType
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/uc/internal/department/getOrganizationalStructureTreeToMTDSByOrgType/get.js
// module id = 1789
// module chunks = 41